import { render, staticRenderFns } from "./salesforce-fields-mapping.vue?vue&type=template&id=2c02539e&scoped=true"
import script from "./salesforce-fields-mapping.vue?vue&type=script&lang=js"
export * from "./salesforce-fields-mapping.vue?vue&type=script&lang=js"
import style0 from "./salesforce-fields-mapping.vue?vue&type=style&index=0&id=2c02539e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02539e",
  null
  
)

export default component.exports